import React, { useEffect, useLayoutEffect, useState } from "react";
import "./ownAgents.scss";
import OwnAgentName from "./ownAgentComp/ownAgentName";
import NumberToCall from "../Agents/numberToCall/NumberToCall";
import ScratchScript from "../Agents/scratchScript";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ownAgents.scss";

const OwnAgents = () => {
  var value = localStorage.getItem("name");
  if (value && value != "undefined") {
    var name = JSON.parse(localStorage.getItem("name"));
  }
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));

  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [agents, setAgents] = useState([]);
  const [showUpdateScript, setUpdateScript] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);

  useEffect(() => {
    fechAgents();
  }, []);

  // const fechAgents = async (data) => {
  //   try {
  //     const token = JSON.parse(localStorage.getItem("bearerToken"));
  //     const requestOptions = {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify(data),
  //     };

  //     fetch(`${process.env.REACT_APP_API_URL}/customer/agents`, requestOptions)
  //       .then((response) => {
  //         console.log("responce :", response);
  //         if (!response.ok) {
  //           throw new Error("Agent Not Found");
  //         }
  //         response.json();
  //       })
  //       .then((data) => {
  //         setAgents(data);
  //       })
  //       .catch((error) => {
  //         console.error("Error during POST request:", error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fechAgents = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("bearerToken"));
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/customer/agents`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.data) {
        throw new Error("Agents not found");
      }

      console.log("responce.data :", response.data);
      setAgents(response.data);
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  const handleButtonClick = () => {
    setIsButtonClicked(true);
  };

  const handleClickAgenData = (item) => {
    setSelectedAgent(item);
  };

  const handleShowScript = () => {
    setIsButtonClicked(false);
    setIsButtonClicked(true);
  };

  const navigate = useNavigate();

  const Logout = () => {
    try {
      localStorage.removeItem("bearerToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("phone");
      localStorage.removeItem("name");
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };


  const handleCLick = () => {
    fechAgents() 
  }

 
  return agents?.length !== 0 ? (
    <>
      {!showUpdateScript ? (
        <div className="nw">
          <div className="ownAgentsWrapper">
            <div className="topBar">
              <div className="bruceDiv">
                <img className="bruceImg" src="/images/Dashboard/bruceImg.png" alt="..." />
                <h3>{name}</h3>
              </div>

              <div className="login-btn" onClick={Logout}>
                <button>Logout</button>
              </div>
            </div>
          </div>

          {!isButtonClicked ? (
            <div>
              <div className="needHelpDiv">
                <a href="/needHelp">Need Help?</a>
              </div>

              <h4 className="pb-4">Own Agents</h4>
              <div className="ownAgentNameWrapper d-flex gap-5 ">
                <div className="ownAgentNameWrapper-box">
                  {agents?.length !== 0 ? (
                    agents?.map((item) => (
                      <div  key={item._id} onClick={() => handleClickAgenData(item)}>
                        <OwnAgentName
                          agent={item}
                          title={item?.agentName}
                          btnShow={true}
                          onClick={handleButtonClick}
                          onButtonClick={setIsButtonClicked}
                          setUpdateScript={setUpdateScript}
                          updateAgents={handleCLick}
                          showUpdate={false}
                        />
                      </div>
                    ))
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <NumberToCall promptType={selectedAgent.promptType} agentData={selectedAgent}/>
          )}

          {/* {isButtonClicked1 && <ScratchScript />} */}
        </div>
      ) : (
        <ScratchScript userId={selectedAgent._id} agentData={selectedAgent} agentPromptType={selectedAgent.promptType} />
      )}
    </>
  ) : (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <h2>No agents found</h2>
  </div>
  );
};

export default OwnAgents;
